var NavbarPages;
(function (NavbarPages) {
    NavbarPages["MARKETPLACE"] = "marketplace";
    NavbarPages["CREATE"] = "create";
    NavbarPages["EXPLORE"] = "explore";
    NavbarPages["LEARN"] = "learn";
    NavbarPages["GOVERNANCE"] = "governance";
    NavbarPages["EXTRA"] = "extra";
})(NavbarPages || (NavbarPages = {}));
export { NavbarPages };
//# sourceMappingURL=Navbar.types.js.map